module.exports = __webpack_public_path__ + "img/no-products.f227bc38.svg";